import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: 'ホーム', href: '#home' },
  { label: '会社概要', href: '#about' },
  { label: 'サービス', href: '#services' },
  { label: 'お問い合わせ', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    if (!isHome) return;
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/db28388e-1886-4a03-9ff8-7fbc590df92f.png"
            alt="株式会社マスター・マインド・グループ ロゴ"
            className="h-10 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
              <a
                key={item.label}
                href={isHome ? item.href : `/${item.href}`}
                onClick={(e) => {
                  if (isHome) {
                    e.preventDefault();
                    handleNavClick(item.href);
                  }
                }}
              className={`text-sm font-medium tracking-wide transition-colors cursor-pointer whitespace-nowrap ${
                scrolled || !isHome ? 'text-gray-700 hover:text-yellow-500' : 'text-white hover:text-yellow-400'
              }`}
            >
              {item.label}
            </a>
          ))}
          <a
            href={isHome ? '#contact' : '/#contact'}
            onClick={(e) => { if (isHome) { e.preventDefault(); handleNavClick('#contact'); } }}
            className="whitespace-nowrap bg-yellow-400 text-gray-900 text-sm font-semibold px-5 py-2 rounded-full hover:bg-yellow-300 transition-colors cursor-pointer"
          >
            無料相談
          </a>
        </nav>

        {/* Hamburger */}
        <button
          className={`md:hidden w-8 h-8 flex flex-col items-center justify-center gap-1.5 cursor-pointer ${scrolled || !isHome ? 'text-gray-800' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニュー"
        >
          <span className={`block w-6 h-0.5 bg-current transition-all ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`block w-6 h-0.5 bg-current transition-all ${menuOpen ? 'opacity-0' : ''}`} />
          <span className={`block w-6 h-0.5 bg-current transition-all ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {navItems.map((item) => (
              <a
                key={item.label}
                href={isHome ? item.href : `/${item.href}`}
                onClick={(e) => {
                  if (isHome) {
                    e.preventDefault();
                    handleNavClick(item.href);
                  }
                }}
                className="text-gray-700 text-sm font-medium py-1 cursor-pointer"
              >
                {item.label}
            </a>
          ))}
          <a
            href={isHome ? '#contact' : '/#contact'}
            onClick={(e) => { if (isHome) { e.preventDefault(); handleNavClick('#contact'); } }}
            className="bg-yellow-400 text-gray-900 text-sm font-semibold px-5 py-2 rounded-full text-center cursor-pointer whitespace-nowrap"
          >
            無料相談
          </a>
        </div>
      )}
    </header>
  );
}
